import moment from "jalali-moment";

export function convertUniversalDateToPersianDate(date) {
    if (date && date.length > 0) {
        return moment(date, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD')
    }
}

export function convertUniversalDateTimeToPersianDateTime(date) {
    if (typeof date !== 'undefined' && date && date.length > 0) {
        const utcDateTime = date.toString().split("T")

        if (typeof utcDateTime !== 'undefined' && typeof utcDateTime[1] !== 'undefined') {

            const utcTime = utcDateTime[1].toString().split(":")

            const newDate = new Date();
            newDate.setUTCHours(utcTime[0], utcTime[1], utcTime[2])

            return `${newDate.toLocaleTimeString('fa-IR')} - ${moment(date, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD')}`
        } else
            return moment(date, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD')
    } else
        return "-"
}

export function convertUniversalDateToPersianDateFullInfo(date) {
    if (date && date.length > 0) {
        return moment(date, 'YYYY-MM-DD').locale('fa').format('dddd . DD MMMM YYYY')
    }
}

export function convertPersianDateToUniversalDate(date) {
    if (date && date.length > 0) {
        return moment.from(date, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
    } else
        return ""
}


export function convertUniversalTimeToPersianTime(time) {
    try {
        return moment(time, 'YYYY-MM-DD').locale('fa').format('HH:mm')
    } catch (e) {
        return "00:00:00"
    }
}